<template>
    <v-text-field v-model='modelValue' variant="outlined" color="widget-color"
        :placeholder="$t('customer-info.general.input.fullname.title')" :rules="rules"
        validate-on="input lazy"></v-text-field>
</template>

<script setup>
import i18n from "@/i18n";
import { defineModel } from "vue"
const modelValue = defineModel({
    required: true,
    type: String
})

const rules = [
    (v) => {
        return !!v || i18n.global.t("customer-info.general.rules.required")
    }
]
</script>

<style lang="scss" scoped></style>